import { Button } from 'components/Buttons/styles'
import styled from 'styled-components'

export const Header = styled.div`
	height: 34.5vh;
  position: absolute;
  top: 0;
  user-select: none;
	width: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  ${Button} {
    position: fixed;
    top: 2.4rem;
    left: 2.9rem;
    z-index: 10;
  }
`

export const Image = styled.img`
  user-select: none;
  background-image: url(${props => props.path});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  opacity: .10;
  mask-image: ${props => props.theme.gradients.blurToBottom};
`